import React, {useState} from 'react';
import {DEFAULT_PRINTFUL_DASHBOARD_TAB, PRINTFUL_DASHBOARD_TABS_LIST} from "../constants/printful.constant";

import ShowTabsList from "../../common/ui/show-tabs-list";
import PrintfulCategoriesList from "./printful-categories/printful-categories-list";
import PrintfulStoresList from "./printful-stores/printful-stores-list";
import PrintfulProductTypesList from "./printful-product-types/printful-product-types-list";
import PrintfulProductsList from "./printful-products/printful-products-list";
import PrintfulProductVariantsList from "./printful-product-variants/printful-product-variants-list";
import PrintfulSyncProductsSyncList from "./printful-sync-products-sync/printful-sync-products-sync-list";
import PrintfulProductsSyncList from "./printful-products-sync/printful-products-sync-list";
import PrintfulSyncProductsList from "./printful-sync-products/printful-sync-products-list";
import PrintfulSyncProductVariantsList from "./printful-sync-product-variants/printful-sync-product-variants-list";
import PrintfulProductsPriceList from "./printful-products-price/printful-products-price-list";


const tabsList = PRINTFUL_DASHBOARD_TABS_LIST;

const PrintfulDashboard = () => {
    const [selectedTab, setSelectedTab] = useState(DEFAULT_PRINTFUL_DASHBOARD_TAB);

    return (
        <>

            <div className="page-container">

                <div className="items-center justify-start p-4 w-full">
                    <div className="flex justify-start m-2 pb-2">
                        <div className="text-xl">
                            Printful
                        </div>
                    </div>


                    <div className="justify-center">

                        <div className="justify-start p-4">

                            <div>
                                <ShowTabsList
                                    setSelectedTab={setSelectedTab}
                                    selectedTab={selectedTab}
                                    tabsList={tabsList}/>
                            </div>

                            <div className="mt-4 px-4">
                                {selectedTab?.key === 'stores' &&
                                    <div>
                                        <PrintfulStoresList/>
                                    </div>
                                }

                                {selectedTab?.key === 'categories' &&
                                    <div>
                                        <PrintfulCategoriesList/>
                                    </div>
                                }

                                {selectedTab?.key === 'productTypes' &&
                                    <div>
                                        <PrintfulProductTypesList/>
                                    </div>
                                }

                                {selectedTab?.key === 'products' &&
                                    <div>
                                        <PrintfulProductsList/>
                                    </div>
                                }


                                {selectedTab?.key === 'productVariants' &&
                                    <div>
                                        <PrintfulProductVariantsList/>
                                    </div>
                                }

                                {selectedTab?.key === 'syncProductsSync' &&
                                    <div>
                                        <PrintfulSyncProductsSyncList/>
                                    </div>
                                }

                                {selectedTab?.key === 'productsSync' &&
                                    <div>
                                        <PrintfulProductsSyncList/>
                                    </div>
                                }

                                {selectedTab?.key === 'syncProducts' &&
                                    <div>
                                        <PrintfulSyncProductsList/>
                                    </div>
                                }

                                {selectedTab?.key === 'syncProductsVariants' &&
                                    <div>
                                        <PrintfulSyncProductVariantsList/>
                                    </div>
                                }

                                {selectedTab?.key === 'productsPrice' &&
                                    <div>
                                        <PrintfulProductsPriceList/>
                                    </div>
                                }

                                {/*
                                {selectedTab?.key === 'syncProductsPrice' &&
                                    <div>
                                        <PrintfulSyncProductsPriceList/>
                                    </div>
                                } */}

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </>
    )
}

export default PrintfulDashboard
